module.exports = __webpack_public_path__ + "assets/img/38-s.72972eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/38-s.jpg
// module id = hyb8
// module chunks = 0